/**
 * Common colors.
 * Generate a name from HEX color: http://chir.ag/projects/name-that-color
 * If the name already exists, try to be creative by adding a suffix :)
 */

/**
 * Monarch approved colors.
 *
 * For all Monarch designs, only pull colors from this colors file.
 * Once everything has been ported over to Monarch we can delete the
 * legacy colors file.
 */
var backgroundGrayLightM = '#F1F1F1';
var backgroundLightM = '#FAFAFA';
var backgroundMediumM = '#F4EEE9';
var backgroundButtonTransparentM = 'rgba(28, 28, 28, 0.15)';
var backgroundButtonTransparentHighlightM = 'rgba(65, 67, 74, 0.35)';
var backgroundCompletelyTransparentM = 'rgba(0, 0, 0, 0)';
var backgroundExtraTransparentM = 'rgba(65, 67, 74, 0.15)';
var backgroundTransparentM = 'rgba(28, 28, 28, 0.5)';
var backgroundTransparentMTextPrimary = 'rgba(65, 67, 74, 0.5)';
var backgroundTranslucentM = 'rgba(28, 28, 28, 0.8)';
var backgroundTranslucentGenesis = 'rgba(0, 0, 0, 0.6)';
var concrete = '#F2F2F2';
var errorM = '#E11E00';
var galleryM = '#EFEFEF';
var grayDarkM = '#41434A';
var grayLightM = '#E8E8E8';
var grayLightTranslucentM = 'rgba(232, 232, 232, 0.5)';
var grayMediumHighlightM = '#646468';
var grayMediumM = '#8B8C90';
var infoBlueM = '#5A9AF9';
var primaryM = '#924B54';
var primaryHighlightM = '#A84C58';
var primaryDisabledM = '#C8A5A9';
var primaryDisabledMTransparent = 'rgba(200,165,169,0.15)';
var primaryPressedM = '#BE585E';
var secondaryHighlightM = '#F9E7EA';
var selectedHighlightM = '#F8FCFF';
var selectedLightHighlightM = '#FBFDFF';
var selectedMediumHighlightM = '#E9F1F7';
var selectedM = '#4E6067';
var selectedTranslucentM = 'rgba(78, 96, 103, 0.3)';
var selectedExtraTranslucentM = 'rgba(78, 96, 103, 0.2)';
var selectedTransparentM = 'rgba(78, 96, 103, 0.05)';
var selectedLightM = '#A4ADB1';
var selectedLightTransparentM = 'rgba(164, 173, 177, 0.15)';
var successM = '#546E7A';
var surfaceM = '#FFFFFF';
var surfaceTranslucentM = "".concat(surfaceM, "B0");
var textDisabledM = '#41434A99';
var textPrimaryM = '#41434A';
var selectedProductCardM = '#EFF3F9';
var easternBlue = '#1D9595';
/**
 * Logo colors.
 */

var logoBlueM = '#698CCF';
var logoDarkBlueM = '#415B82';
var logoGreenM = '#0E7065';
var logoPinkM = '#EB9494';
var logoRedM = '#A84C58';
var logoYellowM = '#ECBC13';
/**
 * Legacy colors.
 */
// blacks

var black = '#000000';
var blackAlpha = '#00000099';
var blackSqueeze = '#EFF3F9';
var blackVeryAlpha = '#00000016';
var lightTransparentBlack = 'rgba(0, 0, 0, 0.2)';
var midTransparentBlack = 'rgba(0, 0, 0, 0.4)';
var quarterTransparentBlack = 'rgba(0, 0, 0, 0.25)';
var semiTransparentBlack = 'rgba(0, 0, 0, 0.8)'; // blues

var blue = '#4978BC';
var blueTint = '#6D93C9';
var darkBlue = '#4B78BA';
var darkerBlue = '#5A85C4';
var darkestBlue = '#263D5D';
var eastBayBlue = '#41538D';
var havelockBlue = '#6885E3';
var hoverBlue = '#B6C9E4';
var hoverFillBlue = '#B8C9E63D';
var jordyBlue = '#7CABEF';
var lightBlue = '#B1CDEC';
var lightHoverBlue = '#EDF2F8';
var paleBlue = '#F2F5F8';
var royalBlue = '#253C5E';
var sanMarinoBlue = '#4C63AD';
var saturatedLightBlue = '#145FCA'; // greens

var darkGreen = '#067039';
var green = '#388D61';
var greenTint = '#388D61'; // others (beiges, browns, pinks, purples)

var dawnPink = '#F4EEE9';
var brown = '#7F4720';
var heather = '#BABFCE';
var flamingo = '#EC583A';
var pink = '#F7ACBC';
var purple = '#1D2E4B';
var sandBeige = '#FDF8F4'; // reds

var red = '#EF4E22';
var redAlert = '#E8371C';
var redDisabled = '#F9B8A7';
var redTint = '#F38364'; // yellows

var yellow = '#FBD206';
var yellowTint = '#FCDF50'; // whites

var catskillWhite = '#E9ECF5';
var packageWhite = '#F4F3F3';
var white = '#FFFFFF';
var whiteHalfAlpha = '#FFFFFF80'; // greys

var alabaster = '#FAFAFA';
var alto = '#E0E0E0';
var altoGrey = '#D1D1D1';
var burnishedSilver = '#C4C4C4';
var buttonGrey = '#CCCCCC';
var darkGrey = '#39393A';
var gallery = '#EDEDED';
var gray = '#8B8B8B';
var grayLighter = '#828282';
var grey = '#747474';
var inputGrey = '#D5D5D5';
var lightGrey = '#E3E1DB';
var mercury = '#E3E3E3';
var midGrey = '#ACA6A2';
var museumGrey = '#F0F0F0';
var seashell = '#F1F1F1';
var semiDarkGrey = '#595959';
var semiTransparentGray = 'rgba(28, 28, 28, 0.5)';
var silver = '#BDBDBD';
var silverChalice = '#B1B1B1';
var textGrey = '#979797';
var transparentGray = "rgba(139, 139, 139, 0.4)";
var wildSandGrey = '#F6F6F6';
export { alabaster, alto, altoGrey, backgroundButtonTransparentHighlightM, backgroundButtonTransparentM, backgroundCompletelyTransparentM, backgroundExtraTransparentM, backgroundGrayLightM, backgroundLightM, backgroundMediumM, backgroundTranslucentGenesis, backgroundTranslucentM, backgroundTransparentM, backgroundTransparentMTextPrimary, black, blackAlpha, blackSqueeze, blackVeryAlpha, blue, blueTint, brown, burnishedSilver, buttonGrey, catskillWhite, concrete, darkBlue, darkGreen, darkGrey, darkerBlue, darkestBlue, dawnPink, eastBayBlue, easternBlue, errorM, flamingo, gallery, galleryM, gray, grayDarkM, grayLightM, grayLightTranslucentM, grayLighter, grayMediumHighlightM, grayMediumM, green, greenTint, grey, havelockBlue, heather, hoverBlue, hoverFillBlue, infoBlueM, inputGrey, jordyBlue, lightBlue, lightGrey, lightHoverBlue, lightTransparentBlack, logoBlueM, logoDarkBlueM, logoGreenM, logoPinkM, logoRedM, logoYellowM, mercury, midGrey, midTransparentBlack, museumGrey, packageWhite, paleBlue, pink, primaryDisabledM, primaryDisabledMTransparent, primaryHighlightM, primaryM, primaryPressedM, purple, quarterTransparentBlack, red, redAlert, redDisabled, redTint, royalBlue, sanMarinoBlue, sandBeige, saturatedLightBlue, seashell, secondaryHighlightM, selectedExtraTranslucentM, selectedHighlightM, selectedLightHighlightM, selectedLightM, selectedLightTransparentM, selectedM, selectedMediumHighlightM, selectedProductCardM, selectedTranslucentM, selectedTransparentM, semiDarkGrey, semiTransparentBlack, semiTransparentGray, silver, silverChalice, successM, surfaceM, surfaceTranslucentM, textDisabledM, textGrey, textPrimaryM, transparentGray, white, whiteHalfAlpha, wildSandGrey, yellow, yellowTint };